export enum MessageTypes {
  error = 'error',
  success = 'success',
  info = 'info',
  empty = 'empty'
}
